import PropTypes from 'prop-types';
import { formatRefDate } from '../../../utils/formatRefDate';
import { visibleChannels, channelLabel, readingText } from '../presentation';

export default function TrendTooltip({ active, payload, label, sensor }) {
    if (!active || !payload?.length) return null;
    const sample = payload[0].payload;
    return <div className="dash-trend-tooltip">
        <time>{formatRefDate(sample.RefDate || label)}</time>
        {!sample.RefDate ? <p>No sample</p> : visibleChannels(sensor).map(channel => <p key={channel}>{channelLabel(sensor, channel)}: <strong>{readingText(sample[channel], sensor, channel)}</strong></p>)}
    </div>;
}

TrendTooltip.propTypes = {
    active: PropTypes.bool, payload: PropTypes.array, label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), sensor: PropTypes.object
};
